import { SendOTPDto } from '../../../dto/otp/sendotp/sendotpdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface SendOTPRequest extends APIRequest
{
    getSendOTPRequest(): SendOTPDto;
}

export class SendOTPRequestImpl extends APIRequestDtoImpl implements SendOTPRequest
{
    constructor(private sendOTPData: SendOTPDto)
    {
        super();
    }

    getSendOTPRequest(): SendOTPDto
    {
        return this.sendOTPData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/sendotp/sendotprequest.tsx